<template>
  <div class="nko-detail-projects">
    <h3 class="nko-detail-projects__title">
      Текущие проекты
    </h3>
    <div class="nko-detail-projects__items">
      <NkoDetailProjectsItem />
      <NkoDetailProjectsItem />
    </div>
    <button type="button" class="nko-detail-projects-button">
      Показать еще
    </button>
  </div>
</template>

<script>
export default {
  name: 'NkoDetailProjects',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.nko-detail-projects {
  margin-bottom: 81px;
  @include tablet{
    margin-bottom: 64px;
  }
  @include mobile{
    margin-bottom: 54px;
  }
  &__title{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    color: #000000;
    margin-bottom: 18px;
    @include mobile{
      margin-bottom: 16px;
    }
  }
  &__items{
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 12px;
    @include mobile{
      grid-row-gap: 28px;
    }
  }
}
.nko-detail-projects-button{
  border: 1px solid #D8DCDE;
  border-radius: 6px;
  height: 50px;
  background-color: transparent;
  width: 100%;
  margin-top: 25px;
  cursor: pointer;
}
</style>